import { Form, useParams } from 'react-router-dom';
import ButtonRow from '@/components/ButtonRow';
import FlashMessage from '@/components/FlashMessage';
import StyledCard from '@/components/StyledCard';
import SubmitButton from '@/components/SubmitButton';
import { usePaymentMethodsLoaderData } from './layout.loader';

export default function PaymentMethodDetails() {
  const { paymentMethods } = usePaymentMethodsLoaderData();
  const { paymentMethodId } = useParams();

  const paymentMethod = paymentMethods.find((pm) => pm.id === paymentMethodId)!;

  return (
    <StyledCard title="Payment Method Details">
      <FlashMessage />
      <Form method="post">
        <p>{paymentMethod.maskedCard}</p>

        <ButtonRow className="mt-3">
          <SubmitButton color="danger">Delete Payment Method</SubmitButton>
        </ButtonRow>
      </Form>
    </StyledCard>
  );
}
